import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MultiSelect } from 'primeng/multiselect';
import { hasControlErrors, translateOptions } from '../../shared/services/select.utils';
import { DomHandler } from 'primeng/dom';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { sortSelectOptionsAscending } from '../select-v2/util/select-v2.util';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
import * as i2 from "@ngx-translate/core";
import * as i3 from "primeng/multiselect";
import * as i4 from "primeng/api";
import * as i5 from "@angular/common";
import * as i6 from "../icon-v2/icon.component";
import * as i7 from "../../shared/directive/tooltip-on-ellipsis-v2.directive";
import * as i8 from "ngx-skeleton-loader";
import * as i9 from "../button-v2/button.component";
import * as i10 from "../field-error/field-error.component";
import * as i11 from "primeng/tooltip";
const _c0 = (a0, a1) => ({
  "dropdown-container-thin": a0,
  "gea-form-container-margin": a1
});
const _c1 = a0 => ({
  "dropdown-thin": a0
});
const _c2 = a0 => ({
  "gea-form-container-margin": a0
});
const _c3 = () => ({
  height: "40px",
  width: "100%"
});
function MultiSelectV2Component_div_0_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("color", ctx_r1.setDropdownIconColor())("file", ctx_r1.isDropdownOpen ? ctx_r1.openIcon : ctx_r1.downIcon);
  }
}
function MultiSelectV2Component_div_0_Conditional_9_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.selectedAsOptions.length + " " + i0.ɵɵpipeBind1(3, 1, ctx_r1.configuration.itemSelectedDescription));
  }
}
function MultiSelectV2Component_div_0_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectV2Component_div_0_Conditional_9_ng_template_0_Template, 4, 3, "ng-template", 7);
  }
}
function MultiSelectV2Component_div_0_ng_template_10_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("pTooltip", option_r3.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r3.name);
  }
}
function MultiSelectV2Component_div_0_ng_template_10_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("pTooltip", i0.ɵɵpipeBind1(1, 2, option_r3.toolTipText));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(option_r3.name);
  }
}
function MultiSelectV2Component_div_0_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectV2Component_div_0_ng_template_10_span_0_Template, 2, 2, "span", 14)(1, MultiSelectV2Component_div_0_ng_template_10_span_1_Template, 3, 4, "span", 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r1.enableTooltipOptionDescription);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.enableTooltipOptionDescription);
  }
}
function MultiSelectV2Component_div_0_ng_template_11_geaui_icon_v2_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 22);
    i0.ɵɵlistener("click", function MultiSelectV2Component_div_0_ng_template_11_geaui_icon_v2_5_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      i0.ɵɵnextContext();
      const searchInput_r6 = i0.ɵɵreference(2);
      const ctx_r1 = i0.ɵɵnextContext(2);
      searchInput_r6.value = "";
      return i0.ɵɵresetView(ctx_r1.onSearchInputClear());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("file", ctx_r1.closeIcon)("clickable", true);
  }
}
function MultiSelectV2Component_div_0_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "input", 19, 1);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("input", function MultiSelectV2Component_div_0_ng_template_11_Template_input_input_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSearchInputChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "geaui-icon-v2", 20);
    i0.ɵɵtemplate(5, MultiSelectV2Component_div_0_ng_template_11_geaui_icon_v2_5_Template, 1, 2, "geaui-icon-v2", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_4_0;
    const searchInput_r6 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 3, (tmp_4_0 = ctx_r1.filterPlaceholderKey) !== null && tmp_4_0 !== undefined ? tmp_4_0 : "UI-LIB.MULTI-SELECT.FILTER-PLACEHOLDER"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("file", ctx_r1.searchIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", searchInput_r6.value !== "");
  }
}
function MultiSelectV2Component_div_0_ng_template_12_div_0_geaui_button_v2_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 27);
    i0.ɵɵlistener("click", function MultiSelectV2Component_div_0_ng_template_12_div_0_geaui_button_v2_4_Template_geaui_button_v2_click_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onTriggerDropdownClear($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("type", "secondary");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, (tmp_6_0 = ctx_r1.configuration == null ? null : ctx_r1.configuration.buttonsConfig == null ? null : ctx_r1.configuration.buttonsConfig.cancelButtonLabel) !== null && tmp_6_0 !== undefined ? tmp_6_0 : "UI-LIB.MULTI-SELECT.CLEAR-ALL"), " ");
  }
}
function MultiSelectV2Component_div_0_ng_template_12_div_0_geaui_button_v2_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 27);
    i0.ɵɵlistener("click", function MultiSelectV2Component_div_0_ng_template_12_div_0_geaui_button_v2_5_Template_geaui_button_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onTriggerDropdownSelectAll());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("type", "secondary");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, (tmp_6_0 = ctx_r1.configuration == null ? null : ctx_r1.configuration.buttonsConfig == null ? null : ctx_r1.configuration.buttonsConfig.selectAllButtonLabel) !== null && tmp_6_0 !== undefined ? tmp_6_0 : "UI-LIB.GENERAL.SELECT-ALL"), " ");
  }
}
function MultiSelectV2Component_div_0_ng_template_12_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "geaui-button-v2", 25);
    i0.ɵɵlistener("click", function MultiSelectV2Component_div_0_ng_template_12_div_0_Template_geaui_button_v2_click_1_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onTriggerDropdownClose());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MultiSelectV2Component_div_0_ng_template_12_div_0_geaui_button_v2_4_Template, 3, 4, "geaui-button-v2", 26)(5, MultiSelectV2Component_div_0_ng_template_12_div_0_geaui_button_v2_5_Template, 3, 4, "geaui-button-v2", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_4_0;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 3, (tmp_4_0 = ctx_r1.configuration == null ? null : ctx_r1.configuration.buttonsConfig == null ? null : ctx_r1.configuration.buttonsConfig.selectButtonLabel) !== null && tmp_4_0 !== undefined ? tmp_4_0 : "X.BUTTON.SELECT"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !(ctx_r1.configuration == null ? null : ctx_r1.configuration.buttonsConfig == null ? null : ctx_r1.configuration.buttonsConfig.hideClearButton) && ctx_r1.selectedAsOptions.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r1.configuration == null ? null : ctx_r1.configuration.buttonsConfig == null ? null : ctx_r1.configuration.buttonsConfig.hideSelectAllButton) && !ctx_r1.selectedAsOptions.length);
  }
}
function MultiSelectV2Component_div_0_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectV2Component_div_0_ng_template_12_div_0_Template, 6, 5, "div", 23);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r1.searchResults === ctx_r1.SearchResults.INIT || ctx_r1.searchResults === ctx_r1.SearchResults.ITEMS_FOUND);
  }
}
function MultiSelectV2Component_div_0_label_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("gea-multiselect-label-disabled", ctx_r1.isDisabled)("gea-multiselect-font-weight-500", ctx_r1.selectedAsOptions.length > 0);
    i0.ɵɵproperty("for", ctx_r1.id + "labelId");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 6, ctx_r1.label), " ");
  }
}
function MultiSelectV2Component_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "span", 4)(2, "p-multiSelect", 5);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵlistener("onLazyLoad", function MultiSelectV2Component_div_0_Template_p_multiSelect_onLazyLoad_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLazyLoad.emit($event));
    })("onFilter", function MultiSelectV2Component_div_0_Template_p_multiSelect_onFilter_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSearchFilter($event));
    })("onChange", function MultiSelectV2Component_div_0_Template_p_multiSelect_onChange_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onToggleOptions($event));
    })("onPanelShow", function MultiSelectV2Component_div_0_Template_p_multiSelect_onPanelShow_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.onToggleDropdown(true);
      ctx_r1.checkDropdownUpwardsOpen();
      return i0.ɵɵresetView(ctx_r1.panelShow.emit());
    })("onPanelHide", function MultiSelectV2Component_div_0_Template_p_multiSelect_onPanelHide_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.onToggleDropdown(false);
      return i0.ɵɵresetView(ctx_r1.panelHide.emit());
    });
    i0.ɵɵtemplate(8, MultiSelectV2Component_div_0_ng_template_8_Template, 1, 2, "ng-template", 6)(9, MultiSelectV2Component_div_0_Conditional_9_Template, 1, 0, null, 7)(10, MultiSelectV2Component_div_0_ng_template_10_Template, 2, 2, "ng-template", 8)(11, MultiSelectV2Component_div_0_ng_template_11_Template, 6, 5, "ng-template", 9)(12, MultiSelectV2Component_div_0_ng_template_12_Template, 1, 1, "ng-template", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, MultiSelectV2Component_div_0_label_13_Template, 3, 8, "label", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "geaui-field-error", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_12_0;
    let tmp_17_0;
    let tmp_25_0;
    let tmp_26_0;
    let tmp_27_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(44, _c0, ctx_r1.size === "small", ctx_r1.size !== "small"))("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("p-float-label", ctx_r1.floatLabelType === "auto");
    i0.ɵɵproperty("ngClass", ctx_r1.alwaysFloatLabel ? "gea-always-float-label" : "");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("gea-multiselect-searchbar", !ctx_r1.hideSearchbar)("isDropdownOpen", ctx_r1.isDropdownOpen)("dropdown-upwards", ctx_r1.isOpenedUpwards);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(47, _c1, ctx_r1.size === "small"))("id", ctx_r1.id)("appendTo", "body")("formControlName", (tmp_12_0 = ctx_r1.formName) !== null && tmp_12_0 !== undefined ? tmp_12_0 : ctx_r1.id)("options", ctx_r1.options)("disabled", ctx_r1.isDisabled)("placeholder", i0.ɵɵpipeBind1(3, 34, ctx_r1.floatLabelType === "never" ? ctx_r1.label : ""))("inputId", ctx_r1.id + "labelId")("filterPlaceHolder", i0.ɵɵpipeBind1(4, 36, (tmp_17_0 = ctx_r1.filterPlaceholderKey) !== null && tmp_17_0 !== undefined ? tmp_17_0 : "UI-LIB.MULTI-SELECT.FILTER-PLACEHOLDER"))("virtualScroll", ctx_r1.virtualScroll)("virtualScrollItemSize", ctx_r1.virtualScrollItemSize)("virtualScrollOptions", ctx_r1.virtualScrollOptions)("lazy", ctx_r1.lazy)("filter", true)("panelStyleClass", ctx_r1.size === "small" ? "multiselect-dropdown-thin" : "")("overlayOptions", ctx_r1.getOverlayOptions())("selectedItemsLabel", i0.ɵɵpipeBind1(5, 38, (tmp_25_0 = ctx_r1.selectedItemsKey) !== null && tmp_25_0 !== undefined ? tmp_25_0 : "UI-LIB.MULTI-SELECT.SELECTED-ITEMS"))("emptyMessage", i0.ɵɵpipeBind1(6, 40, (tmp_26_0 = ctx_r1.emptyMessageKey) !== null && tmp_26_0 !== undefined ? tmp_26_0 : "UI-LIB.MULTI-SELECT.NO-RESULT-FOUND"))("emptyFilterMessage", i0.ɵɵpipeBind1(7, 42, (tmp_27_0 = ctx_r1.emptyFilterMessageKey) !== null && tmp_27_0 !== undefined ? tmp_27_0 : "UI-LIB.MULTI-SELECT.NO-RESULT-FOUND-IN-FILTER"))("maxSelectedLabels", ctx_r1.maxSelectedLabels);
    i0.ɵɵadvance(7);
    i0.ɵɵconditional((ctx_r1.configuration == null ? null : ctx_r1.configuration.itemSelectedDescription) ? 9 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.floatLabelType === "auto");
    i0.ɵɵadvance();
    i0.ɵɵproperty("errors", ctx_r1.control == null ? null : ctx_r1.control.errors);
  }
}
function MultiSelectV2Component_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 30);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2, ctx_r1.size !== "small"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(4, _c3));
  }
}
export var SearchResults;
(function (SearchResults) {
  SearchResults[SearchResults["INIT"] = 0] = "INIT";
  SearchResults[SearchResults["ITEMS_FOUND"] = 1] = "ITEMS_FOUND";
  SearchResults[SearchResults["NO_ITEMS_FOUND"] = 2] = "NO_ITEMS_FOUND";
})(SearchResults || (SearchResults = {}));
export class MultiSelectV2Component {
  formBuilder;
  translateService;
  cdr;
  destroyed;
  id = 'multi-select';
  formName = undefined;
  group;
  label = '';
  size = 'medium';
  required = false;
  loading = false;
  options = [];
  disabled = false;
  selected = [];
  floatLabelType = 'auto';
  validationsError = 'UI-LIB.GENERAL.SELECT-ERROR';
  filterPlaceholderKey;
  selectedItemsKey;
  maxSelectedLabels = 3;
  emptyMessageKey;
  emptyFilterMessageKey;
  hideSearchbar = false;
  enableTooltipOptionDescription = false;
  alwaysFloatLabel = false;
  virtualScroll = false;
  virtualScrollItemSize;
  virtualScrollOptions;
  lazy = false;
  sortOptions = true;
  sortFunction = sortSelectOptionsAscending;
  defaultOpen = false;
  configuration;
  // keeping the property name as onLazyLoad to match the primeNG event name
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  onLazyLoad = new EventEmitter();
  selectChanged = new EventEmitter();
  clearButtonClick = new EventEmitter();
  panelShow = new EventEmitter();
  panelHide = new EventEmitter();
  optionSelected = new EventEmitter();
  multiSelect;
  openIcon = '16px_chevron-up';
  downIcon = '16px_chevron-down';
  searchIcon = '16px_search';
  closeIcon = '16px_close';
  SearchResults = SearchResults;
  selectedAsOptions = [];
  isDropdownOpen = false;
  isOpenedUpwards = false;
  searchResults = SearchResults.INIT;
  cachedLabel = '';
  selectionSaveState = [];
  panelHiddenByClickingSomewhere = false;
  get isDisabled() {
    return this.control?.disabled;
  }
  constructor(formBuilder, translateService, cdr, destroyed) {
    this.formBuilder = formBuilder;
    this.translateService = translateService;
    this.cdr = cdr;
    this.destroyed = destroyed;
    this.group = this.group || this.formBuilder.group({
      [this.formName ?? this.id]: new FormControl(null)
    });
  }
  ngOnInit() {
    if (this.required) this.control?.setValidators([Validators.required]);
    this.translateService.onLangChange.pipe(takeUntilDestroyed(this.destroyed)).subscribe(() => {
      translateOptions(this.options, this.translateService);
      if (this.sortOptions) this.options = this.sortFunction(this.options);
    });
  }
  ngAfterViewInit() {
    if (this.defaultOpen) setTimeout(() => this.multiSelect.show(), 1000);
    if (this.selected.length > 0) {
      this.selectedAsOptions = this.covertToSelectedOptions(this.selected);
      this.setSelectedOptions();
    }
    window.addEventListener('resize', this.alignOverlayPanel.bind(this));
    document.addEventListener('scroll', this.alignOverlayPanel.bind(this), true);
  }
  ngOnChanges(changes) {
    if (changes?.['selected'] && !changes?.['selected'].firstChange) {
      this.selectedAsOptions = this.covertToSelectedOptions(this.selected);
      this.setSelectedOptions();
    }
    if (changes?.['options']) {
      translateOptions(this.options, this.translateService);
      if (this.sortOptions) this.options = this.sortFunction(this.options);
    }
    if (changes?.['label']) {
      this.cachedLabel = this.label;
    }
    if (changes['disabled']) {
      const isDisabled = changes['disabled'].currentValue;
      isDisabled ? this.control?.disable() : this.control?.enable();
    }
  }
  ngOnDestroy() {
    window.removeEventListener('resize', this.alignOverlayPanel.bind(this));
    document.removeEventListener('scroll', this.alignOverlayPanel.bind(this));
  }
  get control() {
    return this.group.get(this.formName ?? this.id);
  }
  getOverlayOptions() {
    return {
      listener: (event, options) => {
        if (options?.type === 'scroll' || options?.type === 'resize') {
          return false;
        }
        return options?.valid;
      }
    };
  }
  hasErrors() {
    return hasControlErrors(this.control);
  }
  onToggleDropdown(open) {
    this.isDropdownOpen = open;
    if (open) {
      this.selectionSaveState = [...this.selectedAsOptions];
    } else if (!open && this.panelHiddenByClickingSomewhere) {
      this.selectedAsOptions = [...this.selectionSaveState];
      this.setSelectedOptions();
    }
    this.panelHiddenByClickingSomewhere = true;
  }
  onTriggerDropdownClear(event) {
    this.panelHiddenByClickingSomewhere = false;
    this.multiSelect?.hide();
    this.multiSelect?.clear(event);
    this.selectedAsOptions = [];
    this.selectionSaveState = [];
    this.toggleLabelCount();
    this.clearButtonClick.emit();
  }
  onTriggerDropdownSelectAll() {
    this.panelHiddenByClickingSomewhere = false;
    this.selectedAsOptions = this.options;
    this.selectionSaveState = this.options;
    this.setSelectedOptions();
    this.multiSelect?.hide();
    this.selectChanged.emit(this.selectedAsOptions);
  }
  onTriggerDropdownClose() {
    this.resetSelectionSaveState();
    this.multiSelect?.hide();
    this.selectChanged.emit(this.selectedAsOptions);
  }
  // has to be public to be used to reset the selectionSaveState from a Client App
  resetSelectionSaveState() {
    this.panelHiddenByClickingSomewhere = false;
    this.selectionSaveState = [];
  }
  onToggleOptions(event) {
    this.optionSelected.emit(event);
    const selectedOption = event.itemValue;
    const optionIndex = this.selectedAsOptions.findIndex(option => option.name === selectedOption.name || option.value === selectedOption.value);
    const isSelected = optionIndex !== -1;
    if (isSelected) this.removeSelectedOption(optionIndex);else this.addSelectedOptions(selectedOption);
  }
  setDropdownIconColor() {
    if (this.isDisabled) return 'grey';
    if (this.multiSelect?.focus || this.hasErrors()) return 'focus';
    return 'blue';
  }
  onSearchFilter(event) {
    const searchInputValue = event.filter?.trim();
    if (!searchInputValue) {
      this.searchResults = SearchResults.INIT;
      return;
    }
    const itemFound = this.options.some(option => option.name?.includes(searchInputValue));
    this.searchResults = itemFound ? SearchResults.ITEMS_FOUND : SearchResults.NO_ITEMS_FOUND;
  }
  onSearchInputChange(event) {
    this.multiSelect.onFilterInputChange(event);
  }
  onSearchInputClear() {
    // input Value is cleared in template to avoid a ViewChild for the input
    this.multiSelect.resetFilter();
  }
  checkDropdownUpwardsOpen() {
    const dropdownPanels = document.body.querySelectorAll('.p-overlay');
    dropdownPanels.forEach(panel => {
      this.isOpenedUpwards = panel.style.transformOrigin === 'center bottom' || panel.style.transformOrigin === 'center bottom 0px';
    });
  }
  alignOverlayPanel() {
    if (!this.isDropdownOpen) {
      return;
    }
    const elements = document.body.getElementsByClassName('p-overlay');
    if (elements.length > 0) {
      const overlay = elements[0];
      DomHandler.alignOverlay(overlay, this.multiSelect?.containerViewChild?.nativeElement, document.body);
    }
    this.checkDropdownUpwardsOpen();
  }
  addSelectedOptions(selectedOption) {
    this.selectedAsOptions.push(selectedOption);
    this.toggleLabelCount();
  }
  setSelectedOptions() {
    if (!this.multiSelect?.value) {
      this.cdr.detectChanges();
    }
    const options = this.findSelectedOptions();
    if (this.multiSelect?.value !== undefined) {
      if (options && options.length > 0) {
        this.multiSelect.value = options;
        this.control?.setValue(options);
      } else {
        this.multiSelect.value = [];
        this.control?.setValue(null);
      }
      this.toggleLabelCount();
    }
  }
  findSelectedOptions() {
    const selectedByValue = this.selectedAsOptions.map(option => option.value);
    return this.options.filter(option => selectedByValue.includes(option.value));
  }
  removeSelectedOption(selectedIndex) {
    this.selectedAsOptions = [...this.selectedAsOptions.filter((_, index) => selectedIndex !== index)];
    this.toggleLabelCount();
  }
  toggleLabelCount() {
    const count = this.selectedAsOptions.length;
    if (count > 0) {
      this.label = this.translateService.instant('UI-LIB.MULTI-SELECT.MULTIPLE-LABEL-FORMAT', {
        selectionCount: `${count}`,
        label: `${this.cachedLabel}`
      });
    } else this.label = this.cachedLabel;
  }
  covertToSelectedOptions(selected) {
    if (!selected.length) return [];
    const isStringArray = typeof selected[0] === 'string';
    if (isStringArray) return selected.map(value => ({
      name: value,
      value: value
    }));
    return selected;
  }
  static ɵfac = function MultiSelectV2Component_Factory(t) {
    return new (t || MultiSelectV2Component)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.DestroyRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MultiSelectV2Component,
    selectors: [["geaui-multi-select-v2"]],
    viewQuery: function MultiSelectV2Component_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(MultiSelect, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiSelect = _t.first);
      }
    },
    inputs: {
      id: "id",
      formName: "formName",
      group: "group",
      label: "label",
      size: "size",
      required: "required",
      loading: "loading",
      options: "options",
      disabled: "disabled",
      selected: "selected",
      floatLabelType: "floatLabelType",
      validationsError: "validationsError",
      filterPlaceholderKey: "filterPlaceholderKey",
      selectedItemsKey: "selectedItemsKey",
      maxSelectedLabels: "maxSelectedLabels",
      emptyMessageKey: "emptyMessageKey",
      emptyFilterMessageKey: "emptyFilterMessageKey",
      hideSearchbar: "hideSearchbar",
      enableTooltipOptionDescription: "enableTooltipOptionDescription",
      alwaysFloatLabel: "alwaysFloatLabel",
      virtualScroll: "virtualScroll",
      virtualScrollItemSize: "virtualScrollItemSize",
      virtualScrollOptions: "virtualScrollOptions",
      lazy: "lazy",
      sortOptions: "sortOptions",
      sortFunction: "sortFunction",
      defaultOpen: "defaultOpen",
      configuration: "configuration"
    },
    outputs: {
      onLazyLoad: "onLazyLoad",
      selectChanged: "selectChanged",
      clearButtonClick: "clearButtonClick",
      panelShow: "panelShow",
      panelHide: "panelHide",
      optionSelected: "optionSelected"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 3,
    vars: 2,
    consts: [["skeleton", ""], ["searchInput", ""], [3, "ngClass", "formGroup", 4, "ngIf", "ngIfElse"], [3, "ngClass", "formGroup"], [1, "gea-multiselect-field", 3, "ngClass"], ["optionLabel", "name", 1, "w-full", 3, "onLazyLoad", "onFilter", "onChange", "onPanelShow", "onPanelHide", "ngClass", "id", "appendTo", "formControlName", "options", "disabled", "placeholder", "inputId", "filterPlaceHolder", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "lazy", "filter", "panelStyleClass", "overlayOptions", "selectedItemsLabel", "emptyMessage", "emptyFilterMessage", "maxSelectedLabels"], ["pTemplate", "dropdownicon"], ["pTemplate", "selectedItems"], ["pTemplate", "item"], ["pTemplate", "filter"], ["pTemplate", "footer"], [3, "gea-multiselect-label-disabled", "gea-multiselect-font-weight-500", "for", 4, "ngIf"], [3, "errors"], [3, "color", "file"], ["class", "pointer-events-auto", "geauiTooltipOnEllipsisV2", "", 3, "pTooltip", 4, "ngIf"], ["class", "pointer-events-auto", 3, "pTooltip", 4, "ngIf"], ["geauiTooltipOnEllipsisV2", "", 1, "pointer-events-auto", 3, "pTooltip"], [1, "pointer-events-auto", 3, "pTooltip"], [1, "p-multiselect-filter-container"], ["type", "text", "role", "searchbox", "autocomplete", "off", "aria-owns", "multi-select_list", 1, "p-multiselect-filter", "p-inputtext", "p-component", 3, "input", "placeholder"], [1, "gea-dropdown-icon", "gea-multiselect-search-icon", 3, "file"], ["class", "gea-dropdown-icon gea-multiselect-close-icon", 3, "file", "clickable", "click", 4, "ngIf"], [1, "gea-dropdown-icon", "gea-multiselect-close-icon", 3, "click", "file", "clickable"], ["class", "gea-multiselect-footer", 4, "ngIf"], [1, "gea-multiselect-footer"], [3, "click"], ["class", "gea-multiselect-footer-clear", 3, "type", "click", 4, "ngIf"], [1, "gea-multiselect-footer-clear", 3, "click", "type"], [3, "for"], [3, "ngClass"], ["count", "1", "appearance", "line", 3, "theme"]],
    template: function MultiSelectV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MultiSelectV2Component_div_0_Template, 15, 49, "div", 2)(1, MultiSelectV2Component_ng_template_1_Template, 2, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const skeleton_r10 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", !ctx.loading)("ngIfElse", skeleton_r10);
      }
    },
    dependencies: [i3.MultiSelect, i4.PrimeTemplate, i1.NgControlStatus, i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormControlName, i5.NgClass, i5.NgIf, i6.IconComponent, i7.TooltipOnEllipsisV2Directive, i8.NgxSkeletonLoaderComponent, i9.ButtonV2Component, i10.FieldErrorComponent, i11.Tooltip, i2.TranslatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-multi-select-v2',
      template: "<div\n  *ngIf=\"!loading; else skeleton\"\n  [ngClass]=\"{ 'dropdown-container-thin': size === 'small', 'gea-form-container-margin': size !== 'small' }\"\n  [formGroup]=\"group\">\n  <span\n    class=\"gea-multiselect-field\"\n    [class.p-float-label]=\"floatLabelType === 'auto'\"\n    [ngClass]=\"alwaysFloatLabel ? 'gea-always-float-label' : ''\">\n    <p-multiSelect\n      class=\"w-full\"\n      [ngClass]=\"{ 'dropdown-thin': size === 'small' }\"\n      [class.gea-multiselect-searchbar]=\"!hideSearchbar\"\n      [class.isDropdownOpen]=\"isDropdownOpen\"\n      [class.dropdown-upwards]=\"isOpenedUpwards\"\n      [id]=\"id\"\n      [appendTo]=\"'body'\"\n      [formControlName]=\"this.formName ?? this.id\"\n      [options]=\"options\"\n      [disabled]=\"isDisabled\"\n      [placeholder]=\"(floatLabelType === 'never' ? label : '') | translate\"\n      [inputId]=\"id + 'labelId'\"\n      [filterPlaceHolder]=\"filterPlaceholderKey ?? 'UI-LIB.MULTI-SELECT.FILTER-PLACEHOLDER' | translate\"\n      [virtualScroll]=\"virtualScroll\"\n      [virtualScrollItemSize]=\"virtualScrollItemSize\"\n      [virtualScrollOptions]=\"virtualScrollOptions\"\n      [lazy]=\"lazy\"\n      [filter]=\"true\"\n      [panelStyleClass]=\"size === 'small' ? 'multiselect-dropdown-thin' : ''\"\n      [overlayOptions]=\"getOverlayOptions()\"\n      [selectedItemsLabel]=\"selectedItemsKey ?? 'UI-LIB.MULTI-SELECT.SELECTED-ITEMS' | translate\"\n      [emptyMessage]=\"emptyMessageKey ?? 'UI-LIB.MULTI-SELECT.NO-RESULT-FOUND' | translate\"\n      [emptyFilterMessage]=\"emptyFilterMessageKey ?? 'UI-LIB.MULTI-SELECT.NO-RESULT-FOUND-IN-FILTER' | translate\"\n      [maxSelectedLabels]=\"maxSelectedLabels\"\n      (onLazyLoad)=\"onLazyLoad.emit($event)\"\n      (onFilter)=\"onSearchFilter($event)\"\n      (onChange)=\"onToggleOptions($event)\"\n      (onPanelShow)=\"onToggleDropdown(true); checkDropdownUpwardsOpen(); panelShow.emit()\"\n      (onPanelHide)=\"onToggleDropdown(false); panelHide.emit()\"\n      optionLabel=\"name\">\n      <ng-template pTemplate=\"dropdownicon\">\n        <geaui-icon-v2 [color]=\"setDropdownIconColor()\" [file]=\"isDropdownOpen ? openIcon : downIcon\"></geaui-icon-v2>\n      </ng-template>\n      @if (configuration?.itemSelectedDescription) {\n        <ng-template pTemplate=\"selectedItems\">\n          <div>\n            <span>{{ selectedAsOptions.length + ' ' + (configuration.itemSelectedDescription | translate) }}</span>\n          </div>\n        </ng-template>\n      }\n      <ng-template let-option pTemplate=\"item\">\n        <span\n          class=\"pointer-events-auto\"\n          *ngIf=\"enableTooltipOptionDescription\"\n          pTooltip=\"{{ option.name }}\"\n          geauiTooltipOnEllipsisV2\n          >{{ option.name }}</span\n        >\n        <span\n          class=\"pointer-events-auto\"\n          *ngIf=\"!enableTooltipOptionDescription\"\n          pTooltip=\"{{ option.toolTipText | translate }}\"\n          >{{ option.name }}</span\n        >\n      </ng-template>\n\n      <ng-template pTemplate=\"filter\">\n        <div class=\"p-multiselect-filter-container\">\n          <input\n            class=\"p-multiselect-filter p-inputtext p-component\"\n            #searchInput\n            [placeholder]=\"filterPlaceholderKey ?? 'UI-LIB.MULTI-SELECT.FILTER-PLACEHOLDER' | translate\"\n            (input)=\"onSearchInputChange($event)\"\n            type=\"text\"\n            role=\"searchbox\"\n            autocomplete=\"off\"\n            aria-owns=\"multi-select_list\" />\n          <geaui-icon-v2 class=\"gea-dropdown-icon gea-multiselect-search-icon\" [file]=\"searchIcon\"> </geaui-icon-v2>\n          <geaui-icon-v2\n            class=\"gea-dropdown-icon gea-multiselect-close-icon\"\n            *ngIf=\"searchInput.value !== ''\"\n            [file]=\"closeIcon\"\n            [clickable]=\"true\"\n            (click)=\"searchInput.value = ''; onSearchInputClear()\">\n          </geaui-icon-v2>\n        </div>\n      </ng-template>\n\n      <ng-template pTemplate=\"footer\">\n        <div\n          class=\"gea-multiselect-footer\"\n          *ngIf=\"searchResults === SearchResults.INIT || searchResults === SearchResults.ITEMS_FOUND\">\n          <geaui-button-v2 (click)=\"onTriggerDropdownClose()\"\n            >{{ configuration?.buttonsConfig?.selectButtonLabel ?? 'X.BUTTON.SELECT' | translate }}\n          </geaui-button-v2>\n          <geaui-button-v2\n            class=\"gea-multiselect-footer-clear\"\n            *ngIf=\"!configuration?.buttonsConfig?.hideClearButton && selectedAsOptions.length\"\n            [type]=\"'secondary'\"\n            (click)=\"onTriggerDropdownClear($event)\">\n            {{ configuration?.buttonsConfig?.cancelButtonLabel ?? 'UI-LIB.MULTI-SELECT.CLEAR-ALL' | translate }}\n          </geaui-button-v2>\n          <geaui-button-v2\n            class=\"gea-multiselect-footer-clear\"\n            *ngIf=\"!configuration?.buttonsConfig?.hideSelectAllButton && !selectedAsOptions.length\"\n            [type]=\"'secondary'\"\n            (click)=\"onTriggerDropdownSelectAll()\">\n            {{ configuration?.buttonsConfig?.selectAllButtonLabel ?? 'UI-LIB.GENERAL.SELECT-ALL' | translate }}\n          </geaui-button-v2>\n        </div>\n      </ng-template>\n    </p-multiSelect>\n    <label\n      *ngIf=\"floatLabelType === 'auto'\"\n      [class.gea-multiselect-label-disabled]=\"isDisabled\"\n      [class.gea-multiselect-font-weight-500]=\"selectedAsOptions.length > 0\"\n      [for]=\"id + 'labelId'\">\n      {{ label | translate }}\n    </label>\n  </span>\n  <geaui-field-error [errors]=\"control?.errors\"></geaui-field-error>\n</div>\n<ng-template #skeleton>\n  <div [ngClass]=\"{ 'gea-form-container-margin': size !== 'small' }\">\n    <ngx-skeleton-loader [theme]=\"{ height: '40px', width: '100%' }\" count=\"1\" appearance=\"line\"></ngx-skeleton-loader>\n  </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }, {
    type: i2.TranslateService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.DestroyRef
  }], {
    id: [{
      type: Input
    }],
    formName: [{
      type: Input
    }],
    group: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    floatLabelType: [{
      type: Input
    }],
    validationsError: [{
      type: Input
    }],
    filterPlaceholderKey: [{
      type: Input
    }],
    selectedItemsKey: [{
      type: Input
    }],
    maxSelectedLabels: [{
      type: Input
    }],
    emptyMessageKey: [{
      type: Input
    }],
    emptyFilterMessageKey: [{
      type: Input
    }],
    hideSearchbar: [{
      type: Input
    }],
    enableTooltipOptionDescription: [{
      type: Input
    }],
    alwaysFloatLabel: [{
      type: Input
    }],
    virtualScroll: [{
      type: Input
    }],
    virtualScrollItemSize: [{
      type: Input
    }],
    virtualScrollOptions: [{
      type: Input
    }],
    lazy: [{
      type: Input
    }],
    sortOptions: [{
      type: Input
    }],
    sortFunction: [{
      type: Input
    }],
    defaultOpen: [{
      type: Input
    }],
    configuration: [{
      type: Input
    }],
    onLazyLoad: [{
      type: Output
    }],
    selectChanged: [{
      type: Output
    }],
    clearButtonClick: [{
      type: Output
    }],
    panelShow: [{
      type: Output
    }],
    panelHide: [{
      type: Output
    }],
    optionSelected: [{
      type: Output
    }],
    multiSelect: [{
      type: ViewChild,
      args: [MultiSelect]
    }]
  });
})();
